import React from 'react';
import styled from 'types/theme.types';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { IconButton } from 'components/common/icon-button';
import { BaseItemContainer } from 'components/layout/navbar/navbar-panel.utils';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

const NavbarCollapse: React.FC = () => {
  const { isCollapsed, toggleCollapsed } = useNavbarCollapse();
  const Glyph = isCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined;

  return (
    <div>
      <BaseItemContainer>
        <OnDarkIconButton
          icon={Glyph}
          size="small"
          dataE2e="navbar-collapse-toggle"
          onClick={toggleCollapsed}
          ariaLabel="toggle navigation"
        />
      </BaseItemContainer>
    </div>
  );
};

/**
 * IconButton is built for the app's light surfaces; only the colours differ on the dark rail. Doubled
 * because a plain `styled(IconButton)` class would tie with IconButton's own and be decided by order.
 */
const OnDarkIconButton = styled(IconButton)`
  && {
    color: var(--text-heading-on-dark);

    &:not(:disabled):hover {
      background-color: var(--surface-navigation-navigation-item);
      color: var(--text-heading-on-dark);
    }
  }
`;

export default NavbarCollapse;
